import { IReducerAction } from '../../../../Hooks/Context/connect';

import Container, { initialState as ContainerInitial, IAuthStateContainer, IAuthContainerReducer } from './ContainerReducer';
import Login, { initialState as LoginInitial, IAuthStateLogin, IAuthLoginReducer } from './LoginReducer';
import SignUp, { initialState as SignUpInitial, IAuthStateSignUp, IAuthSignUpReducer } from './SignUpReducer';

const RESET_REDUCER = 'ROOT:RESET_REDUCER';

type TAuthPartialState = any;

interface IAuthPartialReducer {
    (action: IReducerAction, state: TAuthPartialState): TAuthPartialState
}

interface IAuthState extends Record<string, TAuthPartialState> {
    Login: IAuthStateLogin,
    SignUp: IAuthStateSignUp,
    Container: IAuthStateContainer
}

interface IAuthReducers extends Record<string, IAuthPartialReducer> {
    Login: IAuthLoginReducer,
    SignUp: IAuthSignUpReducer,
    Container: IAuthContainerReducer,
}

interface ICombineReducers {
    (reducers: IAuthReducers): (state: IAuthState, action: IReducerAction) => IAuthState;
}

interface IAuthReducer {
    (state: IAuthState, action: IReducerAction) : IAuthState;
}

const initialState: IAuthState = {
    ...LoginInitial,
    ...SignUpInitial,
    ...ContainerInitial
};

const combineReducers: ICombineReducers = (reducers) => (state, action) => {
    const reducer = Object.keys(reducers).reduce(
        (prevState: IAuthState, reducerName: string) => {
            const currentReducer = reducers[reducerName];

            const partialState: TAuthPartialState = { [reducerName]: prevState[reducerName] };

            const newState: TAuthPartialState = currentReducer(action, partialState);

            return { ...prevState, ...newState };
        },
        state
    );

    return reducer;
};

const appReducer = combineReducers({
    Login,
    SignUp,
    Container
});

const AuthReducer: IAuthReducer = (state, action) => {
    if (action.type === RESET_REDUCER) {
        return appReducer({
            ...initialState,

            Container: {
                ...initialState.Container,
                reset: !state.Container.reset
            }
        }, action);
    }

    return appReducer(state, action);
};

export {
    initialState,
    RESET_REDUCER,
    combineReducers,

    IAuthState,
    TAuthPartialState,
    IAuthPartialReducer
};
export default AuthReducer;
